
  import createMeisterIcons from '../src/createMeisterIcons';

  const Square1 = createMeisterIcons("square-1", [["path",{"fill":"currentColor","d":"M3.75 7A3.26 3.26 0 0 1 7 3.75h10c1.798 0 3.25 1.376 3.25 3.25v.25H3.75zm0 1.75V17A3.26 3.26 0 0 0 7 20.25h10A3.26 3.26 0 0 0 20.25 17V8.75zM7 2.25A4.76 4.76 0 0 0 2.25 7v10A4.76 4.76 0 0 0 7 21.75h10A4.76 4.76 0 0 0 21.75 17V7c0-2.726-2.148-4.75-4.75-4.75z","key":"08585a35bfd4636164c8cde4e65293ae946d868e","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Square1
  